import React from 'react';
import Decimal from 'decimal.js';
import { useTranslation } from 'react-i18next';
import { Currency } from '../Currency/Currency';
import { useIsMobile } from '../utils/useIsMobile';
import { Label } from '../Label/Label';
import { ProfitLossBadge } from '../ProfitLossBadge/ProfitLossBadge';
import { FontSizeType } from '../styles/functions';
import { TypographyFontWeightModel } from '../Typography/tools/Typography.model';
import clsx from 'clsx';

import useStyles from './FundBigChart.style';

export interface ChartMetaData {
  change: number;
  firstValue: number;
  lastValue: number;
  firstDate: string;
  lastDate: string;
  selectedRange?: string;
}

const ChartPricingBox: React.FC<{ chartMetadata: ChartMetaData }> = ({ chartMetadata }) => {
  const c = useStyles({});
  const [t] = useTranslation('components');
  const isMobile = useIsMobile();

  const currencyProps: { valueSize: FontSizeType; codeSize: FontSizeType; valueFontWeight: TypographyFontWeightModel } = {
    valueSize: isMobile ? 'xl' : 'xxl',
    codeSize: isMobile ? 'xl' : 'xxl',
    valueFontWeight: 'bold',
  };

  return (
    <div className={c.pricingBox}>
      <div className={clsx(c.pricingHeaderBox, c.pricingHeaderROIBox)}>
        <Label color="graphite" size="s">
          {t('fundChart.roi')}
          {chartMetadata.selectedRange && ` ${chartMetadata.selectedRange}`}
        </Label>
        <ProfitLossBadge
          value={new Decimal(chartMetadata.change * 100)}
          suffix='%'
          variant='big'
        />
      </div>
      <div className={c.pricingBoxRow}>
        <div className={c.pricingHeaderBox}>
          <Label color="graphite" size="s">{t('fundChart.pricing-for')} {chartMetadata.firstDate}</Label>
          <Currency
            value={chartMetadata.firstValue}
            {...currencyProps}
          />
        </div>
        <div className={c.pricingHeaderBox}>
          <Label color="graphite" size="s">{t('fundChart.pricing-for')} {chartMetadata.lastDate}</Label>
          <Currency
            value={new Decimal(chartMetadata.lastValue)}
            {...currencyProps}
          />
        </div>
      </div>
    </div>
  );
};

export default ChartPricingBox;
